import React from "react";
import  ReactDOM  from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css"
import "./css/style.css"   
import App from "./ComingSoon/App";
// ####################################################################
// #                                        #
// #import App from "./component/App";                                 #
// #const root = ReactDOM.createRoot(document.getElementById("root")); #
// #root.render(<App/>)                                                #
// ####################################################################
const root= ReactDOM.createRoot(document.getElementById("root"));
root.render(<App/>)